<template>
  <ScrollTop v-if="showScrollTop" />
  <div class="params-row request-and-check-all">
    <SwitchSlide
      :is-active="!store.bypassQueryActivities"
      @toggle="toggleUseRequest"
      >Utiliser la requête</SwitchSlide
    >
    <CheckBox
      :checked="isAllSelected"
      @update:checked="
        () => (isAllSelected ? unselectAllFilters() : selectAllFilters())
      "
    >
      Toutes les activités
    </CheckBox>
  </div>
  <div class="params-row">
    <div class="page-settings filters">
      <FilterCheckBox
        label="Publications"
        color="var(--clr-network)"
        :item-count="store.indexCount?.publications"
        :is-checked="
          store.prmActivitiesFilters.includes(ACTIVITIES_FILTERS.PUBLICATIONS)
        "
        @check="addFilter(ACTIVITIES_FILTERS.PUBLICATIONS)"
        @uncheck="removeFilter(ACTIVITIES_FILTERS.PUBLICATIONS)"
      />
      <FilterCheckBox
        label="Dossiers Législatifs"
        color="var(--color-legidocs)"
        :item-count="store.indexCount?.['legi-doc']"
        :is-checked="
          store.prmActivitiesFilters.includes(ACTIVITIES_FILTERS.LEGIDOCS)
        "
        @check="addFilter(ACTIVITIES_FILTERS.LEGIDOCS)"
        @uncheck="removeFilter(ACTIVITIES_FILTERS.LEGIDOCS)"
      />
      <FilterCheckBox
        label="Amendements"
        color="var(--color-amendments)"
        :item-count="store.indexCount?.amendment"
        :is-checked="
          store.prmActivitiesFilters.includes(ACTIVITIES_FILTERS.AMENDMENTS)
        "
        @check="addFilter(ACTIVITIES_FILTERS.AMENDMENTS)"
        @uncheck="removeFilter(ACTIVITIES_FILTERS.AMENDMENTS)"
      />
      <FilterCheckBox
        label="Questions"
        color="var(--color-questions)"
        :item-count="store.indexCount?.question"
        :is-checked="
          store.prmActivitiesFilters.includes(ACTIVITIES_FILTERS.QUESTIONS)
        "
        @check="addFilter(ACTIVITIES_FILTERS.QUESTIONS)"
        @uncheck="removeFilter(ACTIVITIES_FILTERS.QUESTIONS)"
      />
      <FilterCheckBox
        label="Compte-rendus"
        color="var(--color-reports)"
        :item-count="store.indexCount?.['compte-rendu']"
        :is-checked="store.prmActivitiesFilters.includes(ACTIVITIES_FILTERS.CR)"
        @check="addFilter(ACTIVITIES_FILTERS.CR)"
        @uncheck="removeFilter(ACTIVITIES_FILTERS.CR)"
      />
    </div>

    <div class="page-settings">
      <DropdownMenu
        v-model="selectedLimitOption"
        :options="limitOptions"
        label="Activités par page :"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";

import SwitchSlide from "@follaw-fr/components/reusable/atoms/SwitchSlide.vue";
import CheckBox from "@follaw-fr/components/reusable/atoms/CheckBox.vue";
import FilterCheckBox from "@follaw-fr/components/reusable/atoms/FilterCheckBox.vue";
import { usePrmStore } from "@follaw-fr/stores/prm";
import { ACTIVITIES_FILTERS } from "@follaw-fr/stores/prm";
import ScrollTop from "@follaw-fr/components/reusable/atoms/ScrollTop.vue";
import DropdownMenu from "@follaw-fr/components/reusable/atoms/DropdownMenu.vue";
import { useDropdown } from "@follaw-fr/composables/useDropdown";

const route = useRoute();
const store = usePrmStore();

const props = defineProps({
  isZoomed: {
    type: Boolean,
    default: false,
  },
});

const { selectedPrmActivitiesParams } = storeToRefs(store);

const fetchActivities = async () => {
  selectedPrmActivitiesParams.value.from = 0;
  if (props.isZoomed) {
    await store.fetchOnePersonnalityActivities(route.params._id);
  } else {
    await store.fetchFollawedPrmActivities();
  }
};

const { options: limitOptions, selectedValue: selectedLimitOption } =
  useDropdown({
    options: { 10: "10", 20: "20", 50: "50", 200: "200" },
    selectedFilters: selectedPrmActivitiesParams,
    filterKey: "size",
    onChange: () => {
      fetchActivities();
    },
  });

const addFilter = (filter) => {
  store.prmActivitiesFilters.push(filter);
  fetchActivities();
};

const removeFilter = (filter) => {
  store.prmActivitiesFilters = store.prmActivitiesFilters.filter(
    (f) => f !== filter
  );
  fetchActivities();
};

const selectAllFilters = () => {
  store.prmActivitiesFilters = [
    ACTIVITIES_FILTERS.PUBLICATIONS,
    ACTIVITIES_FILTERS.LEGIDOCS,
    ACTIVITIES_FILTERS.AMENDMENTS,
    ACTIVITIES_FILTERS.QUESTIONS,
  ];
  fetchActivities();
};

const unselectAllFilters = () => {
  store.prmActivitiesFilters = [];
  fetchActivities();
};

const isAllSelected = computed(
  () =>
    store.prmActivitiesFilters.length ===
    Object.keys(ACTIVITIES_FILTERS)?.length
);

const toggleUseRequest = () => {
  store.bypassQueryActivities = !store.bypassQueryActivities;
  fetchActivities();
};

const showScrollTop = computed(
  () => selectedPrmActivitiesParams.value.size > 0
);

fetchActivities();
</script>

<style lang="scss" scoped>
.request-and-check-all {
  justify-content: flex-start;
  gap: 15px;
}
.filters {
  gap: 10px;
}
</style>
